<template>
  <div>
    <div>
      <p class="contentType">
        <span>Condition Type:</span>
        <span>{{ formName }}</span>
      </p>
    </div>
    <el-form :model="form" :rules="rules" ref="form">
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item label="Parent name:" prop="parentName">
            <el-input style="width: 300px" v-model="form.parentName"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="Consolidated audited financials within days:"
            prop="consolidatedAuditedFinancialsWithinDays"
          >
            <el-input
              style="width: 300px"
              v-model="form.consolidatedAuditedFinancialsWithinDays"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <common-form ref="commonForm" :defaultData="_commonData"></common-form>
  </div>
</template>

<script>
import CommonForm from './common-form'
export default {
  components: { CommonForm },
  data() {
    return {
      formName: 'PFIN',
      form: {
        parentName: '',
        consolidatedAuditedFinancialsWithinDays: '',
      },
      commonFormData: {},
      rules: {
        parentName: [
          { required: true, message: 'can not be empty!', trigger: 'blur' },
        ],
        consolidatedAuditedFinancialsWithinDays: [
          { required: true, message: 'can not be empty!', trigger: 'blur' },
        ],
      },
    }
  },
  watch: {
    d_value: {
      deep: true,
      immediate: true,
      handler(newValue) {
        this.commonFormData = newValue
        this.$set(this.form, 'parentName', newValue.parentName)
        this.$set(
          this.form,
          'consolidatedAuditedFinancialsWithinDays',
          newValue.consolidatedAuditedFinancialsWithinDays,
        )
      },
    },
  },
  props: {
    d_value: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    _commonData() {
      return {
        ...this.commonFormData,
      }
    },
  },
  methods: {
    getFormData() {
      return {
        ...this.form,
        formName: this.formName,
        ...this.$refs.commonForm.getCommonForm(),
      }
    },
    async checkValid() {
      const valid = await this.$refs.form.validate()
      if (valid) {
        return await this.$refs.commonForm.checkCommonValid()
      } else {
        return false
      }
    },
  },
}
</script>

<style scoped lang="less">
.contentType {
  margin-bottom: 10px;

  span {
    font-size: 14px;
    font-weight: bold;
    color: #303133;
    &:first-child {
      margin-right: 10px;
    }
  }
}
</style>
